import { OFFERS_TYPES } from 'enums'
import { isDirectSallingTypes } from 'vars'
import { applyThousandSeparator } from 'react-number-format/lib/utils'
import { isCdmxOrEdoMexOrLeon } from 'utils/vta'

const useOffers = (offers, branchId) => {
  const directSalling = offers?.length > 0
    ? offers?.find((e) => isDirectSallingTypes?.includes(e?.offer_type) && e?.show_price)
    : null

  const directEasyOffer = offers?.length > 0
    ? offers?.find((e) => `${e?.offer_type}`.includes('easy directo') && e?.show_price)
    : null

  const traditionalEasyOffer = offers?.length > 0
    ? offers?.find((e) => `${e?.offer_type}`.includes('easy tradicional'))
    : null

  let offerType = OFFERS_TYPES.EASY_NO_ESTIMATED
  let offerSelected = null

  if (directSalling) {
    offerType = OFFERS_TYPES.DIRECT_SALLING
    offerSelected = directSalling
    // eslint-disable-next-line max-len
  } else if (traditionalEasyOffer && traditionalEasyOffer?.show_price && !isCdmxOrEdoMexOrLeon(branchId)) {
    offerType = OFFERS_TYPES.EASY_ESTIMATED
    offerSelected = traditionalEasyOffer
    // eslint-disable-next-line max-len
  } else if (traditionalEasyOffer && !traditionalEasyOffer?.show_price && !isCdmxOrEdoMexOrLeon(branchId)) {
    offerType = OFFERS_TYPES.EASY_NO_ESTIMATED
    offerSelected = traditionalEasyOffer
  } else if (directEasyOffer && isCdmxOrEdoMexOrLeon(branchId)) {
    offerType = OFFERS_TYPES.EASY_ESTIMATED
    offerSelected = directEasyOffer
  } else {
    offerType = OFFERS_TYPES.EASY_NO_ESTIMATED
  }

  const minOffer = applyThousandSeparator(
    `$${Math.ceil(offerSelected?.min_offer)}`,
    ',',
  )
  const maxOffer = applyThousandSeparator(
    `$${Math.ceil(offerSelected?.max_offer)}`,
    ',',
  )

  // Solo SI existe una oferta tipo b2c
  const inmediateOffer = offers?.find(
    (o) => o?.offer_type === 'b2c' && o?.show_price === true,
  )

  const buttonId = offerSelected?.offer_type.includes('easy')
    ? 'vta_agenda_cita_easy'
    : 'vta_agenda_cita_venta_directa'

  return {
    offer: offerSelected,
    easyOffer: directEasyOffer,
    traditionalEasyOffer,
    offerType,
    isDirectSalling: Boolean(directSalling),
    minOffer,
    maxOffer,
    buttonId,
    inmediateOffer,
  }
}

export default useOffers
